module.exports = __webpack_public_path__ + "static/media/play-button.ebbb2682.svg";